const CLASSNAME = 'form'; // ?should this be implemented
const emailRegex = '^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$';
const websiteUrlRegex =
  '^(https?:\\/\\/)?(www\\.)?[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?))*\\.[a-zA-Z]{2,}(\\/[^\\s]*)?$';

const FORM_SCHEMA = {
  type: 'object',
  properties: {
    // --- Your details
    countryId: {
      fieldId: 'countryId',
      label: 'Country',
      showInForm: true,
      formFieldType: 'select',
      isRequired: true,
      placeholder: 'Please choose...',
      type: 'string',
      minLength: 1,
      errorMessage: 'Please fill this in',
      options: [],
      section: 0
    },
    department: {
      fieldId: 'department',
      label: 'Department name',
      showInForm: true,
      formFieldType: 'text',
      placeholder: '',
      type: 'string',
      minLength: 1,
      errorMessage: 'Please fill this in',
      isRequired: true,
      section: 0
    },
    address1: {
      fieldId: 'address1',
      label: 'Department Address 1',
      showInForm: true,
      formFieldType: 'text',
      placeholder: '',
      type: 'string',
      minLength: 1,
      errorMessage: 'Please fill this in',
      isRequired: true,
      section: 0
    },
    address2: {
      fieldId: 'address2',
      label: 'Department Address 2',
      showInForm: true,
      formFieldType: 'text',
      placeholder: '',
      type: 'string',
      minLength: 1,
      errorMessage: 'Please fill this in',
      isRequired: false,
      section: 0
    },
    county: {
      fieldId: 'county',
      label: 'State/County',
      showInForm: true,
      formFieldType: 'text',
      placeholder: '',
      type: 'string',
      minLength: 1,
      errorMessage: 'Please fill this in',
      isRequired: true,
      section: 0
    },
    university: {
      fieldId: 'university',
      label: 'University Name',
      showInForm: true,
      formFieldType: 'text',
      placeholder: '',
      type: 'string',
      minLength: 1,
      errorMessage: 'Please fill this in',
      isRequired: true,
      section: 0
    },
    town: {
      fieldId: 'town',
      label: 'City/Town',
      showInForm: true,
      formFieldType: 'text',
      placeholder: '',
      type: 'string',
      minLength: 1,
      errorMessage: 'Please fill this in',
      isRequired: true,
      section: 0
    },
    postcode: {
      fieldId: 'postcode',
      label: 'Post code / Zip code',
      showInForm: true,
      formFieldType: 'text',
      placeholder: '',
      type: 'string',
      minLength: 1,
      errorMessage: 'Please fill this in',
      isRequired: true,
      section: 0
    },
    email: {
      fieldId: 'email',
      label: 'Academic email',
      showInForm: true,
      formFieldType: 'email',
      placeholder: '',
      type: 'string',
      pattern: emailRegex,
      errorMessage: `Please enter a valid email address`,
      isRequired: true,
      section: 0
    },
    webpage: {
      fieldId: 'webpage',
      label: 'Academic / staff profile page URL',
      showInForm: true,
      formFieldType: 'text',
      placeholder: '',
      type: 'string',
      pattern: websiteUrlRegex,
      errorMessage: `Please enter a valid website URL`,
      isRequired: true,
      section: 0
    }
  },

  required: [
    'countryId',
    'department',
    'address1',
    'town',
    'postcode',
    'email',
    'university',
    'county',
    'webpage'
  ]
};

export { CLASSNAME, FORM_SCHEMA };
